export const isClient = () => typeof window < "u"
